import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=bb4a634c"
import script from "../../services/teacher/edit-teacher.js?vue&type=script&lang=js&external"
export * from "../../services/teacher/edit-teacher.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/edit-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports